import * as React from "react";

import { useScrollToErrorInForm2023 } from "../../Common";

export const DeliveryDetailsFormAutoScrolling: React.FunctionComponent = () => {
  useScrollToErrorInForm2023({
    cssSelectorBase: "form.delivery-details",
    overrideScrollToCustomField: () => {
      if (typeof document === "undefined") {
        return null;
      }

      const form = document.querySelector("form.delivery-details");
      if (!(form instanceof HTMLElement)) {
        return null;
      }

      if (form.querySelector(".input-container.error")) {
        return ".input-container.error";
      }

      const activeSavedAddressSection = form.querySelector(
        ".address.AddressFormPresentationType-LoggedInCustomerSavedAddresses"
      );
      const hasSelectedSavedAddress = !!form.querySelector(
        ".address.AddressFormPresentationType-LoggedInCustomerSavedAddresses .saved-address.currently-selected"
      );
      if (activeSavedAddressSection && !hasSelectedSavedAddress) {
        return ".address.AddressFormPresentationType-LoggedInCustomerSavedAddresses";
      }

      return null;
    },
  });

  return null;
};
